import React from 'react';
import { Space, Progress, Divider, Button } from 'antd';
import '../styles/card.css';
import {
	AppstoreOutlined, MailOutlined, SettingOutlined, MenuUnfoldOutlined, MenuFoldOutlined, ToolOutlined, DeleteOutlined, DragOutlined,
	FontSizeOutlined,
	BarcodeOutlined,
	BorderOutlined,
	LineOutlined,
	QrcodeOutlined,
	MinusCircleOutlined,
	DownloadOutlined,
	PlayCircleOutlined,
	ClockCircleOutlined,
	CheckCircleOutlined,
	InfoCircleOutlined,
	FileDoneOutlined,
	TableOutlined
 
 } from '@ant-design/icons';
import {
	DEFAULT_HISTORICO_LIST_ID,
	DEFAULT_RESULTADO_LIST_ID,
} from '../constants/listConstants';

 const CardIcon = ({type}) => {
	if(type == 1){
		return(<ClockCircleOutlined style={{ fontSize: 48 }}/>);
	}else if(type == 2){
		return(<FileDoneOutlined style={{ fontSize: 48 }}/>);
	}else{
		return(<TableOutlined style={{ fontSize: 48 }}/>);
	}
 }

const CardList = ({ card, onSettingsClick, running = false }) => {

	const showSettings = card.id !== DEFAULT_HISTORICO_LIST_ID && card.id !== DEFAULT_RESULTADO_LIST_ID;

	return (
		<div className="card" style={{ width: (290), padding: 5, position: 'relative' }}>
			{showSettings && (
				<Button
					type="text"
					size="small"
					icon={<SettingOutlined />}
					aria-label="Configurações"
					disabled={running}
					onClick={(e) => {
						e.stopPropagation();
						onSettingsClick?.(card);
					}}
					style={{
						position: 'absolute',
						top: 4,
						right: 4,
						zIndex: 1,
					}}
				/>
			)}
			<div className="container">
				<Space direction="horizontal" style={{ width: '100%', justifyContent: 'center' }}>
					<h3 style={{ color: 'black' }}>{card.id} - <b>{card.name}</b></h3>
				</Space>
				<Divider style={{marginTop:0, marginBottom: 10}}/>			
				<Space direction="horizontal" style={{ width: '100%', justifyContent: 'center' }}>
					<CardIcon type={card.type}/>
				</Space>
				<Space direction="horizontal" style={{ width: '100%', justifyContent: 'center' }}>
					<h3 style={{ color: 'black',fontWeight:'normal' }}>{card.qtd}</h3>
				</Space>
			</div>
		</div>
	);

};

export default CardList;